export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/(admin)/agents": [10,[2]],
		"/(admin)/agents/[agent]": [11,[2,3]],
		"/(admin)/agents/[agent]/agent": [12,[2,3]],
		"/(admin)/agents/[agent]/feeds": [13,[2,3]],
		"/(admin)/agents/[agent]/knowledge": [14,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/activity": [15,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/calendar": [16,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/entities/[key]": [17,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/schema": [18,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/tables": [19,[2,3,4]],
		"/(admin)/agents/[agent]/knowledge/trackers": [20,[2,3,4]],
		"/(admin)/agents/[agent]/manifesto": [21,[2,3]],
		"/(admin)/agents/[agent]/narratives": [22,[2,3]],
		"/(admin)/agents/[agent]/prompts": [23,[2,3]],
		"/(admin)/agents/[agent]/sources": [24,[2,3]],
		"/(admin)/agents/[agent]/training": [25,[2,3]],
		"/(admin)/agents/[agent]/users": [26,[2,3]],
		"/(admin)/dashboard": [27,[2]],
		"/(admin)/knowledge": [28,[2,5]],
		"/(admin)/knowledge/activity": [29,[2,5]],
		"/(admin)/knowledge/calendar": [30,[2,5]],
		"/(admin)/knowledge/entities": [31,[2,5]],
		"/(admin)/knowledge/entities/[key]": [32,[2,5]],
		"/(admin)/knowledge/merges": [33,[2,5]],
		"/(admin)/knowledge/trackers": [34,[2,5]],
		"/(admin)/library": [35,[2]],
		"/(admin)/news": [36,[2,6]],
		"/(admin)/news/[agent]": [37,[2,6]],
		"/(admin)/news/[agent]/[id]": [38,[2,6]],
		"/(admin)/sources": [39,[2]],
		"/(admin)/system": [40,[2,7]],
		"/(admin)/system/getty": [41,[2,7]],
		"/(admin)/system/prompts": [42,[2,7]],
		"/(admin)/system/status": [43,[2,7]],
		"/(admin)/system/users": [44,[2,7,8]],
		"/(admin)/system/users/accounts": [45,[2,7,8]],
		"/(admin)/system/users/accounts/[ref]": [46,[2,7,8]],
		"/(admin)/system/users/audit": [47,[2,7,8]],
		"/(admin)/system/users/tiers": [48,[2,7,8]],
		"/(admin)/system/users/usage": [49,[2,7,8]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';